import React from 'react'
import PropTypes from 'prop-types'
import { Button, Modal } from 'react-bootstrap'

const FIELDS = [
  { value: 'Points', label: 'Points' },
  { value: 'Started', label: 'Start Time' },
  { value: 'Submitted', label: 'Submission Time' },
  { value: 'Graded', label: 'Grade Time' },
]

const FILETYPES = [
  { value: 'xlsx', label: 'Microsoft Excel', icon: 'fal fa-file-excel' },
  { value: 'csv', label: 'Comma Delimited Text', icon: 'fal fa-file-csv' },
]

const FORMATS = [
  { value: 'standard', label: 'Standard' },
  { value: 'canvas', label: 'Canvas-upload Compatible' },
]

class DownloadWidget extends React.Component {
  constructor() {
    super()
    this.submitForm = this.submitForm.bind(this)
    this.handleFileType = this.handleFileType.bind(this)
    this.handleFormat = this.handleFormat.bind(this)
    this.handleCheckbox = this.handleCheckbox.bind(this)
    this.state = {
      showDownloadForm: false,
      fileType: 'xlsx',
      format: 'standard',
      includeFilters: false,
      actPointTotalsRow: false,
      totalLTILaunchesAndSubmissions: false,
      fieldPoints: false,
      fieldStarted: false,
      fieldSubmitted: false,
      fieldGraded: false,
    }
  }

  static propTypes = {
    filters: PropTypes.object,
    startDownload: PropTypes.func.isRequired,
    showAccountingButton: PropTypes.bool,
    isCanvasCourse: PropTypes.bool,
  }

  submitForm(event) {
    event.target.disabled = true

    let fields = FIELDS.map(({ value }) => 'field' + value)
      .filter(field => this.state[field])
      .map(field => field.slice(5))

    this.setState({ showDownloadForm: false })

    const data = {
      fileType: this.state.fileType,
      format: this.state.format,
      pointTotals: this.state.actPointTotalsRow,
      totalLTILaunchesAndSubmissions: this.state.totalLTILaunchesAndSubmissions,
      fields,
    }
    const filters = this.state.includeFilters ? { ...this.props.filters } : {}

    this.props.startDownload(data, filters)
  }

  handleFileType(event) {
    let checked = event.target.checked
    if (checked) {
      this.setState({
        fileType: event.target.value,
      })
    }
  }

  handleFormat(event) {
    let checked = event.target.checked
    if (checked) {
      this.setState({
        format: event.target.value,
      })
    }
  }

  handleCheckbox(event) {
    let name = event.target.name
    let checked = event.target.checked
    this.setState({
      [name]: checked,
    })
  }

  renderForm() {
    let filetypes = FILETYPES.map(({ value, label, icon }) => (
      <label className="radio-inline" key={value}>
        <input
          type="radio"
          name="fileType"
          value={value}
          checked={this.state.fileType === value}
          onChange={this.handleFileType}
        />
        <span className={icon} /> {label}
      </label>
    ))

    let formats = FORMATS.map(({ value, label }) => (
      <label className="radio-inline" key={value}>
        <input
          type="radio"
          name="format"
          value={value}
          checked={this.state.format === value}
          onChange={this.handleFormat}
        />
        {label}
      </label>
    ))

    let fields = FIELDS.map(({ value, label }) => (
      <div className="checkbox" key={value}>
        <label>
          <input
            type="checkbox"
            name={`field${value}`}
            checked={this.state[`field${value}`]}
            onChange={this.handleCheckbox}
          />
          {label}
        </label>
      </div>
    ))

    return (
      <div className="form-horizontal">
        <div className="form-group">
          <label className="control-label">
            <strong>File Type:</strong>
          </label>
          <div>{filetypes}</div>
        </div>
        {this.props.isCanvasCourse && (
          <div className="form-group">
            <label className="control-label">
              <strong>Format:</strong>
            </label>
            <div>{formats}</div>
          </div>
        )}
        <div className="form-group">
          <label className="control-label">
            <input
              type="checkbox"
              name="includeFilters"
              checked={this.state.includeFilters}
              onChange={this.handleCheckbox}
            />
            <strong className="ml-2">Apply Filters</strong>
          </label>
        </div>
        <div className="form-group">
          <label className="control-label">
            <input
              type="checkbox"
              name="actPointTotalsRow"
              checked={this.state.actPointTotalsRow}
              onChange={this.handleCheckbox}
            />
            <strong className="ml-2">
              Include Activity Points on First Row
            </strong>
          </label>
        </div>
        {this.props.showAccountingButton && (
          <div className="form-group">
            <label className="control-label">
              <input
                type="checkbox"
                name="totalLTILaunchesAndSubmissions"
                checked={this.state.totalLTILaunchesAndSubmissions}
                onChange={this.handleCheckbox}
              />
              <strong className="ml-2">
                Include Columns for Total LTI Launches and Assessment
                Submissions
              </strong>
            </label>
          </div>
        )}
        <div className="form-group">
          <label className="control-label">
            <strong>Optional Fields:</strong>
          </label>
          <div>{fields}</div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="d-inline ml-3">
        <Button
          id="downloadGradebookButton"
          bsStyle="primary"
          onClick={() => this.setState({ showDownloadForm: true })}
          className="btn-myed btn-primary-myed"
        >
          <i className="fas fa-arrow-to-bottom icon_color_white" /> Download
          Gradebook
        </Button>
        <Modal
          show={this.state.showDownloadForm}
          onHide={() => this.setState({ showDownloadForm: false })}
        >
          <Modal.Header>
            <Modal.Title>Download Gradebook</Modal.Title>
          </Modal.Header>
          <Modal.Body>{this.renderForm()}</Modal.Body>
          <Modal.Footer>
            <Button
              id="cancelButton"
              onClick={() => this.setState({ showDownloadForm: false })}
              className="btn-myed btn-default-myed"
            >
              Cancel
            </Button>
            <Button
              id="startDownloadGradebookButton"
              onClick={this.submitForm}
              bsStyle="primary"
              className="btn-myed btn-primary-myed"
            >
              <i className="fas fa-arrow-to-bottom" /> Download
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}

export default DownloadWidget
